import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import AntropometriaViewer from '../components/AntropometriaViewer';

export default function AntropometriaDetailPage() {
  const { medidaId, pacienteId } = useParams();

  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <AntropometriaViewer medidaId={medidaId} pacienteId={pacienteId} />
      </Container>
    </DashboardLayout>
  );
}
